<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>

      <BackButton
          :label="$t('general.button.back')"
          :to="{ name: 'analyticsHome' }"
          marginBottom="5"/>

      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          Coachübersicht
        </h6>
      </div>

      <div class="element-box">
        <Search
            :filters="filters"
            @search="getCoachList"/>

        <div class="row align-items-center justify-content-between">
          <div class="mt-4">
            <PerPage
                :values="[10, 25, 50, 100]"
                @update:perPage="getCoachList"/>

            <ExcelExportButton
                style="margin-right: 15px;"
                :label="$t('general.excel_export')"
                :loading="isExcelLoaded"
                @click="getExcelExport"/>
          </div>
        </div>

        <div class="table-responsive overflow-auto pt-4 mb-3">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Mitarbeiter Nr.</th>
              <th>Name</th>
              <th>Typ</th>
              <th>Standort</th>
              <th class="text-end">Active Kunden</th>
              <th class="text-end">Behandelte</th>
              <th class="text-end">Stunden</th>
              <th class="text-end">Geleistete UE</th>
              <th class="text-end">Einzelcoaching</th>
              <th class="text-end">Gruppenmaßnahmen</th>
              <th class="text-end">Soziotherapie</th>
              <th class="text-end">Betreutes Wohnen</th>
              <th class="text-end">Private Weiterbildung</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="coach in coachList.data" :key="coach.id">
              <td>{{ coach?.employeeNumber }}</td>
              <td>{{ coach?.fullName }}</td>
              <td>{{ coach?.type }}</td>
              <td>{{ coach?.locations }}</td>
              <td class="text-end">{{ coach?.activeCoaching }}</td>
              <td class="text-end">{{ coach?.treatedCoaching }}</td>
              <td class="text-end">{{ coach?.workingHours }}</td>
              <td class="text-end">{{ coach?.totalUnits }}</td>
              <td class="text-end">{{ coach?.totalPrivateCoachingUnits }}</td>
              <td class="text-end">{{ coach?.totalGroupCoachingUnits }}</td>
              <td class="text-end">{{ coach?.totalSocioTherapyCoachingUnits }}</td>
              <td class="text-end">{{ coach?.totalAssistedLivingCoachingUnits }}</td>
              <td class="text-end">{{ coach?.totalPrivateLearningCoachingUnits }}</td>
              <td class="text-end"></td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination
            v-if="coachList?.pagination?.total_pages > 1"
            :totalPages="coachList?.pagination?.total_pages"
            :currentPage="coachList?.pagination?.current_page"
            :totalItems="coachList?.pagination?.total_items"
            :perPage="coachList?.pagination?.items_per_page"
            @pagechanged="getCoachList"/>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup>

import analyticsCoachEvaluationService from '@/api/Analytics/Coach/index';
import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {ErrorToast} from '@/components/VueToast';
import {downloadFile} from '@/shared/functions';
import Search from '@/views/App/Analytics/Coach/Overview/Search.vue';
import {onMounted, ref} from 'vue';
import ExcelExportButton from "@/components/ExcelExportButton.vue";
import BackButton from "@/components/button/BackButton.vue";

const isSearching = ref(false);
const isLoaded = ref(false);
const coachList = ref([]);
const isExcelLoaded = ref(false);
const filters = ref({
  lastName: '',
  startDate: '',
  endDate: '',
});

async function getCoachList(page = 1, perPage, passedFilters) {

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = coachList.value?.pagination?.items_per_page;

  try {
    const {data} = await analyticsCoachEvaluationService.getCoachOverviewList({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    coachList.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

async function getExcelExport() {
  await downloadFile('/analytics/coach/overview/excel-export',
      undefined,
      filters.value,
      false,
      "GET",
      isExcelLoaded
  )
}


onMounted(async () => {
  await Promise.all([
    getCoachList(),
  ]);

  isLoaded.value = true;
});
</script>

<style scoped>

</style>